import React from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import BaseModal from "./BaseModal";
import activeModalState from "../../state/ui/activeModalState";
import UpdateProfile from "../UpdateProfile";
import useUpdateUser from "../../hooks/forms/useUpdateUser";
import {useFormatValidationErrors} from "../../hooks/response";
import {toast} from "react-toastify";
import useTiming from "../../hooks/useTiming";
import windowDimensionState from "../../state/ui/windowDimensionState";
import { useTranslation } from "react-i18next";

export default function ProfileModal() {
  const {t} = useTranslation(['lounge', 'error'])
  const timing = useTiming();
  const [activeModal, setShowModal] = useRecoilState(activeModalState);
  const windowDimensions = useRecoilValue(windowDimensionState);
  const {formik, mutation} = useUpdateUser({
    onError: () => {
      toast(t('error:unable-to-update-profile'), {type: 'error', autoClose: false});
    },
    onSuccess: () => {
      toast(t('profile-update-successfully'));
      windowDimensions.width > 768 && setShowModal('');
    }
  });
  const errors = useFormatValidationErrors(mutation.error || {}, formik.errors);

  return (
    <BaseModal show={activeModal === 'profile'} title={t('profile')}>
      <div className="w-full">
        <UpdateProfile
          avatar={true}
          name={true}
          email={false}
          phone={false}
          company={false}
          location={false}
          remarks={false}
          formik={formik}
          errors={errors}
        />
      </div>
      <div className="">
        <button type={'submit'} onClick={formik.handleSubmit} disabled={formik.isSubmitting} className="btn-primary">{formik.values.avatar ? t('confirm') : t('update')}</button>
      </div>
    </BaseModal>
  )
}
